/**
 * @generated SignedSource<<1325bab3e09ee1fe5d6427377673083d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MismatchedAddressContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsuredModalBase_viewer">;
  readonly " $fragmentType": "MismatchedAddressContent_viewer";
};
export type MismatchedAddressContent_viewer$key = {
  readonly " $data"?: MismatchedAddressContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MismatchedAddressContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MismatchedAddressContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsuredModalBase_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d61d5b7fde889f777b2d491bad1c530f";

export default node;
